import { Fragment } from 'react';
import { useCalendar } from '../../Context.js';
import { deriveWeeks, getWeekdays } from '../../utils/index.js';
import { Weekdays, Weekday, DatePickerBody } from '../../styled.js';
import Week from './Week.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function DatePicker() {
  var _useCalendar = useCalendar(),
    locale = _useCalendar.locale,
    timeZone = _useCalendar.timeZone,
    weekStartsOn = _useCalendar.weekStartsOn,
    focusedDate = _useCalendar.focusedDate;
  var weekdayFormat = new window.Intl.DateTimeFormat(locale, {
    weekday: 'short',
    timeZone: timeZone
  });
  var weeks = deriveWeeks({
    date: focusedDate,
    weekStartsOn: weekStartsOn
  });
  var weekdays = getWeekdays({
    date: focusedDate,
    weekStartsOn: weekStartsOn
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Weekdays, {
      children: weekdays.map(function (weekday) {
        return /*#__PURE__*/jsx(Weekday, {
          children: weekdayFormat.format(weekday)
        }, weekday.toString());
      })
    }), /*#__PURE__*/jsx(DatePickerBody, {
      children: weeks.map(function (week) {
        return /*#__PURE__*/jsx(Week, {
          date: week
        }, week.toString());
      })
    })]
  });
}

export { DatePicker };
